import { RewardModel } from '@shared/types';
import { transformRewardsFromObjectToMap } from '@shared/utils';

import { ReferralUserRewardUpdateFormValues } from '../ReferralUserRewardUpdateForm';

export const getUserRewardProgressEditFormInitialValues = (
  personalChance: Record<string, number>,
  initialRewards: RewardModel[]
): ReferralUserRewardUpdateFormValues => ({
  personalChance: transformRewardsFromObjectToMap(personalChance, initialRewards),
});
